import React, { useContext } from 'react';
import { Divider, Space } from 'antd';

import CriticalFindingsTooltip from '@totem/components/common/findings/CriticalFindingsTooltip';
import SurveyContext from '@totem/components/surveyV2/instanceDetail/SurveyInstanceContext';
import { ticketStyles } from '@totem/components/ticketing/details/ticketStyles';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';

import '../survey.css';

const styles = {
  divider: {
    height: '12rem',
  },
};

const OverviewCard = () => {
  const { data } = useContext(SurveyContext);
  const { survey } = data;
  const { totalQuestions, completedQuestions, criticalFindings } = survey;

  const percentage = totalQuestions
    ? `${Math.round((completedQuestions / totalQuestions) * 100)}%`
    : '0%';

  return (
    <IBCard title="Overview" variant="borderless">
      <Space align="center" orientation="horizontal" size="small">
        <div styleName="progress-container">
          <div styleName="progress-title">Progress</div>
          <div styleName="progress">
            <div
              styleName="percentage"
              style={{ color: ticketStyles.colors.negative }}
            >
              {percentage}
            </div>
            <div styleName="ratio">{`${completedQuestions} / ${totalQuestions}`}</div>
          </div>
        </div>
        <Divider orientation="vertical" style={styles.divider} />
        <div styleName="critical-findings-container">
          <div styleName="critical-findings-title-container">
            <div styleName="critical-findings-title">CFs</div>
            <CriticalFindingsTooltip />
          </div>
          <div styleName="critical-findings">{criticalFindings}</div>
        </div>
        {/* TODO: Implement CSV Export */}
        {/*<div styleName="csv-export">*/}
        {/*  <Button onClick={onCSVExport}>Export CSV</Button>*/}
        {/*</div>*/}
      </Space>
    </IBCard>
  );
};

export default OverviewCard;
